import { Atom, List, X } from "@phosphor-icons/react";
import { useState, type ReactNode } from "react";
import { Link, NavLink } from "react-router-dom";
import { usePortfolio } from "../state/PortfolioContext";
import { trackContactClick } from "../infrastructure/analytics";

const nav = [["/", "Início"], ["/criacao-de-sites-em-brasilia", "Sites em Brasília"], ["/sobre", "Sobre"], ["/experiencia", "Experiência"], ["/projetos", "Projetos"], ["/metodo", "Método"], ["/contato", "Contato"]] as const;

export function Brand() {
  return <Link className="brand" to="/" aria-label="Atlas de Sistemas, início"><Atom className="brand-mark" aria-hidden="true" /><span><strong>ATLAS DE SISTEMAS</strong><small>YURI WINCHESTER</small></span></Link>;
}

export function PublicShell({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const { settings } = usePortfolio();
  return <div className="site-shell">
    <a className="skip-link" href="#conteudo">Pular para o conteúdo</a>
    <header className="site-header"><Brand /><button className="menu-button" onClick={() => setOpen(!open)} aria-expanded={open} aria-controls="site-nav">{open ? <X /> : <List />}<span className="sr-only">Menu</span></button><nav id="site-nav" className={open ? "nav open" : "nav"} aria-label="Principal">{nav.map(([href, label]) => <NavLink key={href} to={href} onClick={() => setOpen(false)}>{label}</NavLink>)}</nav></header>
    <main id="conteudo">{children}</main>
    <footer className="site-footer"><div><Brand /><p>Engenharia de software que resolve.</p></div><div className="footer-contact"><a href={`mailto:${settings.email}`} onClick={() => trackContactClick("email", "footer")}>{settings.email}</a><a href={`tel:${settings.phoneE164}`} onClick={() => trackContactClick("phone", "footer")}>{settings.phoneDisplay}</a><span>{settings.location}</span></div></footer>
  </div>;
}

export function SectionLabel({ children, tone = "blue" }: { children: ReactNode; tone?: "blue" | "orange" | "green" }) {
  return <p className={`section-label ${tone}`}><span>{children}</span></p>;
}

export function PageIntro({ eyebrow, title, description }: { eyebrow: string; title: string; description: string }) {
  return <section className="page-intro"><SectionLabel>{eyebrow}</SectionLabel><h1>{title}</h1><p>{description}</p></section>;
}
